// components/subscription/SubscriptionStats.jsx
import React, {useEffect} from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';

const SubscriptionStats = () => {
  const { 
    subscriptionStatus, 
    fetchSubscriptionStatus,
    loading, 
    error 
  } = useSubscription();

  useEffect(() => {
    fetchSubscriptionStatus();
  });

  if (loading) return <div className="text-center py-8">Loading subscription stats...</div>;
  if (error) return <div className="text-center text-red-600 py-8">{error}</div>;
  if (!subscriptionStatus) return <div className="text-center py-8">No subscription stats available</div>;

  console.log(subscriptionStatus, typeof(subscriptionStatus));
  const { 
    days_remaining, 
    // renewal_date, 
    amount_paid,
    // billing_cycle, 
    transaction_id,
    usage_stats = {} 
  } = subscriptionStatus.subscription;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">Subscription Overview</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-blue-50 p-4 rounded-lg">
          <div className="text-sm text-blue-800 mb-1">Days Remaining</div>
          <div className="text-2xl font-bold text-blue-900">{days_remaining}</div>
        </div>
        
        <div className="bg-green-50 p-4 rounded-lg">
          <div className="text-sm text-green-800 mb-1">Amount Paid</div>
          <div className="text-2xl font-bold text-green-900">₹{parseFloat(amount_paid).toFixed(2)}</div>
          <div className="text-xs text-green-700 mt-1">
            Transaction Id: {transaction_id ? transaction_id : 'N/A'}
          </div>
        </div>
      </div>
      
      {usage_stats && Object.keys(usage_stats).length > 0 && (
        <div className="mt-6">
          <h3 className="text-lg font-medium mb-3">Usage Statistics</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {Object.entries(usage_stats).map(([key, value]) => (
              <div key={key} className="bg-gray-50 p-4 rounded-lg">
                <div className="text-sm text-gray-600 mb-1">
                  {key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                </div>
                <div className="text-xl font-semibold">{value}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionStats;